import {
  Article,
  ArticleResolution,
} from '@wix/answers-api';
import classNames from 'classnames';
import React, { useState } from 'react';

import type { Step } from '../../pages/article/[articleTitle]';
import { ArticleABTestNotification } from '../ArticleABTestNotification';
import { ArticlePreviewNotification } from '../ArticlePreviewNotification';
import { BreadcrumbItem } from '../Breadcrumbs';
import { ArticleLeftPanel } from './ArticleLeftPanel';
import { ArticleMainContent } from './ArticleMainContent';

import css from './index.module.scss';

export type ArticlePageLayoutProps = {
  article: Article;
  relatedArticles: Article[];
  steps: Step[];
  breadcrumbItems: BreadcrumbItem[];
  copilotArticleContentRef: React.RefObject<HTMLDivElement>;
  anchorsRef: React.RefObject<HTMLDivElement>;
  isLoading: boolean;
  selfArticleRedirect: (
    url: string,
    shallow?: boolean,
    targetLocale?: string
  ) => void;
  onClickStatus: (resolution: ArticleResolution) => Promise<void>;
};

export const ArticlePageLayout = ({
  article,
  relatedArticles,
  steps,
  breadcrumbItems,
  copilotArticleContentRef,
  anchorsRef,
  isLoading,
  selfArticleRedirect,
  onClickStatus,
}: ArticlePageLayoutProps) => {
  const [isLeftPanelCollapsed, setLeftPanelCollapsed] = useState(false);
  const hasSteps = steps.length > 0;
  const showLeftPanel = hasSteps && !isLeftPanelCollapsed;
  const showCollapsedPanel = hasSteps && isLeftPanelCollapsed;

  return (
    <>
      <ArticlePreviewNotification />
      <ArticleABTestNotification article={article} />
      <div
        className={classNames(css.articlePageLayout, {
          [css.leftPanelVisible]: showLeftPanel,
          [css.leftPanelCollapsed]: showCollapsedPanel,
        })}
      >
        {hasSteps && (
          <ArticleLeftPanel
            steps={steps}
            article={article}
            copilotArticleContentRef={copilotArticleContentRef}
            anchorsRef={anchorsRef}
            isCollapsed={isLeftPanelCollapsed}
            onCollapse={() => setLeftPanelCollapsed(true)}
            onExpand={() => setLeftPanelCollapsed(false)}
          />
        )}
        <ArticleMainContent
          article={article}
          relatedArticles={relatedArticles}
          steps={steps}
          breadcrumbItems={breadcrumbItems}
          copilotArticleContentRef={copilotArticleContentRef}
          isLoading={isLoading}
          selfArticleRedirect={selfArticleRedirect}
          onClickStatus={onClickStatus}
        />
      </div>
    </>
  );
};
